// Auto-generated for /pages/faq during Magento → Shopify migration.
// Loaded with <script defer> so DOM is ready before this runs.

(function() {
    'use strict';

    var FAQ_DATA = [
        {
            id: 'hours',
            title: 'Business Hours',
            icon: 'clock',
            fullWidth: true,
            items: [
                { text: '8:00 AM – 5:00 PM CST, Monday through Friday', isBadge: true }
            ]
        },
        {
            id: 'shipping',
            title: 'Shipping & Transportation',
            icon: 'truck',
            items: [
                { text: 'All prices are <strong>FOB shipping point</strong>. Freight charges are prepaid and added to the invoice.' },
                { text: 'For ground shipments, we ship freight collect. Please specify a carrier or we will ship via best way.' },
                { text: 'We make every effort to package products to prevent damage during transit.' },
                { text: 'Your total cost, including shipping charges, will be provided when your order is invoiced.' },
                { text: 'Tracking numbers are sent via email when your order ships.' },
                { text: 'If shipments arrive damaged, mark accordingly on the shipping papers and contact the carrier to file a claim.' },
                { text: 'We cannot be responsible for carrier mishandling, but will assist with claims any way we can.' }
            ]
        },
        {
            id: 'pricing',
            title: 'Pricing',
            icon: 'tag',
            items: [
                { text: 'Prices are based on current manufacturer schedules and are subject to change without notice.' },
                { text: 'Prices remain stable except for metals, bar and wire solder, which are subject to daily market changes.' },
                { text: 'All pricing is in <strong>US dollars</strong>.' },
                { text: 'We offer <strong>price breaks</strong> for many items. Please call for details.' },
                { text: 'Placing a <strong>blanket order</strong> will lock in your price for those items.' },
                { text: 'Not responsible for typographical errors.' }
            ]
        },
        {
            id: 'terms',
            title: 'Payment Terms',
            icon: 'credit-card',
            items: [
                { text: 'Terms are <strong>Net 30</strong> for customers with an established account.' },
                { text: 'To apply for credit, please submit your bank information, three credit references, and number of years in business.' },
                { text: 'We accept <strong>Visa, MasterCard, and American Express</strong> for your convenience.' },
                { text: 'Questions or credit applications? <a href="mailto:lhillers@technimark-inc.com">Email us</a> or call our team.' }
            ]
        },
        {
            id: 'tax',
            title: 'Sales Tax',
            icon: 'percent',
            items: [
                { text: 'State sales/use tax is charged and collected in states where we have sales representatives servicing accounts (NEXUS).' },
                { text: 'Sales tax applies to all purchases, only for items left in or shipped with the end product (solder, labels, ESD, etc.).' }
            ]
        }
    ];

    var ICONS = {
        clock: '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><circle cx="12" cy="12" r="10"></circle><polyline points="12 6 12 12 16 14"></polyline></svg>',
        truck: '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><rect x="1" y="3" width="15" height="13"></rect><polygon points="16 8 20 8 23 11 23 16 16 16 16 8"></polygon><circle cx="5.5" cy="18.5" r="2.5"></circle><circle cx="18.5" cy="18.5" r="2.5"></circle></svg>',
        tag: '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M20.59 13.41l-7.17 7.17a2 2 0 0 1-2.83 0L2 12V2h10l8.59 8.59a2 2 0 0 1 0 2.82z"></path><line x1="7" y1="7" x2="7.01" y2="7"></line></svg>',
        'credit-card': '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><rect x="1" y="4" width="22" height="16" rx="2" ry="2"></rect><line x1="1" y1="10" x2="23" y2="10"></line></svg>',
        percent: '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><line x1="19" y1="5" x2="5" y2="19"></line><circle cx="6.5" cy="6.5" r="2.5"></circle><circle cx="17.5" cy="17.5" r="2.5"></circle></svg>'
    };

    function createFaqCategory(category) {
        var card = document.createElement('div');
        card.className = 'faq-category' + (category.fullWidth ? ' full-width' : '');

        var headerHtml = '<div class="faq-category-header">' +
            '<div class="faq-category-icon">' + ICONS[category.icon] + '</div>' +
            '<h2>' + category.title + '</h2>' +
            '</div>';

        var contentHtml = '<div class="faq-category-content">';
        category.items.forEach(function(item) {
            if (item.isBadge) {
                contentHtml += '<div class="hours-badge">' + ICONS.clock + ' ' + item.text + '</div>';
            } else {
                contentHtml += '<div class="faq-item">' + item.text + '</div>';
            }
        });
        contentHtml += '</div>';

        card.innerHTML = headerHtml + contentHtml;
        return card;
    }

    function renderFaq() {
        var grid = document.getElementById('faqGrid');
        if (!grid) return;
        var fragment = document.createDocumentFragment();
        FAQ_DATA.forEach(function(category) {
            fragment.appendChild(createFaqCategory(category));
        });
        grid.appendChild(fragment);
    }

    function init() {
        renderFaq();
    }

    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', init);
    } else {
        init();
    }
})();